import * as React from "react";
import PropTypes from "prop-types";
import camelCase from "lodash-es/camelCase";

const LeftScreen = ({ gradient, name }) => {
  const gradientName = `leftScreenGradient-${camelCase(name)}`;

  return (
    <svg viewBox="0 0 268 390" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id={gradientName} x1="0" y1="0" x2="0" y2="1">
          {gradient.map((color, i) => (
            <stop
              key={`left-screen-${i}`}
              stopColor={color}
              offset={i / Math.max(1, gradient.length - 1)}
            ></stop>
          ))}
        </linearGradient>
      </defs>
      <path
        d="M0 4C0 1.79086 1.79086 0 4 0H264C266.209 0 268 1.79086 268 4V386C268 388.209 266.209 390 264 390H4C1.79086 390 0 388.209 0 386V4Z"
        fill={`url(#${gradientName})`}
      />
      <rect
        x="180"
        y="20.5"
        width="16"
        height="16"
        fill="white"
        fillOpacity="0.16"
      />
      <rect
        x="212"
        y="20.5"
        width="16"
        height="16"
        fill="white"
        fillOpacity="0.16"
      />
      <rect
        x="244"
        y="20.5"
        width="16"
        height="16"
        fill="white"
        fillOpacity="0.16"
      />
      <rect
        x="8"
        y="77"
        width="120"
        height="16"
        fill="white"
        fillOpacity="0.16"
      />
      <rect
        x="8"
        y="109"
        width="120"
        height="16"
        fill="white"
        fillOpacity="0.16"
      />
      <rect
        x="8"
        y="129"
        width="73"
        height="16"
        fill="white"
        fillOpacity="0.08"
      />
      <rect
        x="144"
        y="109"
        width="56"
        height="12"
        fill="white"
        fillOpacity="0.16"
      />
      <rect
        x="204"
        y="109"
        width="56"
        height="12"
        fill="white"
        fillOpacity="0.16"
      />
      <rect
        x="8"
        y="161"
        width="120"
        height="16"
        fill="white"
        fillOpacity="0.16"
      />
      <rect
        x="8"
        y="181"
        width="73"
        height="16"
        fill="white"
        fillOpacity="0.08"
      />
      <rect
        x="144"
        y="161"
        width="56"
        height="12"
        fill="white"
        fillOpacity="0.16"
      />
      <rect
        x="204"
        y="161"
        width="56"
        height="12"
        fill="white"
        fillOpacity="0.16"
      />
      <rect
        x="8"
        y="213"
        width="120"
        height="16"
        fill="white"
        fillOpacity="0.16"
      />
      <rect
        x="8"
        y="233"
        width="73"
        height="16"
        fill="white"
        fillOpacity="0.08"
      />
      <rect
        x="144"
        y="213"
        width="56"
        height="12"
        fill="white"
        fillOpacity="0.16"
      />
      <rect
        x="204"
        y="213"
        width="56"
        height="12"
        fill="white"
        fillOpacity="0.16"
      />
      <rect
        x="8"
        y="265"
        width="120"
        height="16"
        fill="white"
        fillOpacity="0.16"
      />
      <rect
        x="8"
        y="285"
        width="73"
        height="16"
        fill="white"
        fillOpacity="0.08"
      />
      <rect
        x="144"
        y="265"
        width="56"
        height="12"
        fill="white"
        fillOpacity="0.16"
      />
      <rect
        x="204"
        y="265"
        width="56"
        height="12"
        fill="white"
        fillOpacity="0.16"
      />
      <rect
        x="8"
        y="317"
        width="120"
        height="16"
        fill="white"
        fillOpacity="0.16"
      />
      <rect
        x="8"
        y="337"
        width="73"
        height="16"
        fill="white"
        fillOpacity="0.08"
      />
      <rect
        x="144"
        y="317"
        width="56"
        height="12"
        fill="white"
        fillOpacity="0.16"
      />
      <rect
        x="204"
        y="317"
        width="56"
        height="12"
        fill="white"
        fillOpacity="0.16"
      />
    </svg>
  );
};

LeftScreen.propTypes = {
  gradient: PropTypes.arrayOf(PropTypes.string),
  name: PropTypes.string,
};

export default LeftScreen;
